import { Injectable, inject } from "@angular/core";

import { DataSearchService } from "@tylertech/data-load-module";
import { IInfoCardData, ISearchCriteria, } from "@tylertech/tyler-api-types";

import { SearchUrlService } from "./searchUrlService";
import { StorageService } from "@tylertech/core-module";

@Injectable()
export class SearchService<TItem = IInfoCardData>
{
    private readonly $dataSearchService = inject<DataSearchService<TItem>>(DataSearchService);
    private readonly $searchUrlService = inject(SearchUrlService);
    private $storageService = inject(StorageService);


    isGridView(providerId: string): boolean
    {
        const savedGridView = this.$storageService.Get<Record<string, boolean>>(StorageKey.UserPreferredViews) || {};

        return savedGridView[providerId] || false;
    }

    setGridView(providerId: string, isGridView: boolean): void
    {
        const savedGridView = this.$storageService.Get<Record<string, boolean>>(StorageKey.UserPreferredViews) || {};
        savedGridView[providerId] = isGridView;
        this.$storageService.Set(StorageKey.UserPreferredViews, savedGridView);
    }

    getCriteria(providerId: string): Promise<ISearchCriteria<TItem>>
    {
        return this.$dataSearchService.GetCriteria(providerId)
            .then(
                (result: ISearchCriteria<TItem>) =>
                {
                    // this.criteria = result;

                    // TODO - why isn't this set on the backend?
                    result.SearchProviderId = providerId;

                    this.$searchUrlService.updateCriteria(result);

                    const savedGridView = this.$storageService.Get<Record<string, boolean>>(StorageKey.UserPreferredViews) || {};
                    const gridViewDefault = result.Settings
                        && this.getSetting(result, "GridViewDefault") === true;

                    this.setGridView(providerId, !savedGridView
                        ? gridViewDefault
                        : savedGridView[providerId]);

                    // if (this.gridView)
                    // {
                    //     this.Search(result, this.pager.selectedPage, this.criteria.From);
                    // }
                    return result;
                });
    }

    hasSetting(criteria: ISearchCriteria<TItem>, settingName: string): boolean
    {
        return criteria?.Settings
            ? settingName in criteria.Settings
            : false;
    }

    getSetting<T>(criteria: ISearchCriteria<TItem>, settingName: string): T
    {
        return criteria?.Settings
            ? criteria.Settings[settingName]
            : undefined;
    }

    setSetting<T>(criteria: ISearchCriteria<TItem>, settingName: string, value: T): void
    {
        if (!criteria)
        {
            return;
        }

        if (!criteria.Settings)
        {
            criteria.Settings = {};
        }

        criteria.Settings[settingName] = value;
    }
}

const enum StorageKey
{
    UserPreferredViews = "saved_grid_view",
}
